(function(){
'use strict';

/* ── i18n (riadené Shopify prepínačom jazyka, nie prehliadačom) ── */
const CFG=document.getElementById('racemOfferPage').dataset;
const EN = CFG.en === 'true';
const ROOT = (CFG.root || '/').replace(/\/+$/, '');
const LOCALE = CFG.locale || 'sk';
const NUM_LOCALE = EN ? 'en-US' : 'sk-SK';
const SORT_LOCALE = EN ? 'en' : 'sk';

const T = EN ? {
  allBrands:'All makes', allModels:'All models', pickBrand:'Select a make first',
  allYears:'All years', allCategories:'All categories', allVendors:'All manufacturers',
  loading:'Loading products...', loadError:'Loading error', loadFailed:'Could not load products.',
  noProducts:'No products', loadMore:'Load more', products:'products',
  from:'From', price:'Price', certificate:'Certificate', certified:'Certified',
  chipBrand:'Make', chipModel:'Model', chipYear:'Year', chipCategory:'Category',
  chipPriceFrom:'Price from', chipPriceTo:'Price to', chipSort:'Sort',
  chipVendor:'Manufacturer', certWith:'With certificate', certWithout:'Without certificate',
  addToCart:'Add to cart', adding:'Adding...', added:'In cart', chooseVariant:'Choose option', detail:'Detail',
  cartError:'Could not add to cart'
} : {
  allBrands:'Všetky značky', allModels:'Všetky modely', pickBrand:'Najprv vyber značku',
  allYears:'Všetky roky', allCategories:'Všetky kategórie', allVendors:'Všetci výrobcovia',
  loading:'Načítavam produkty...', loadError:'Chyba načítania', loadFailed:'Nepodarilo sa načítať produkty.',
  noProducts:'Žiadne produkty', loadMore:'Načítať ďalšie', products:'produktov',
  from:'Od', price:'Cena', certificate:'Certifikát', certified:'Certifikát',
  chipBrand:'Značka', chipModel:'Model', chipYear:'Rok', chipCategory:'Kategória',
  chipPriceFrom:'Cena od', chipPriceTo:'Cena do', chipSort:'Triedenie',
  chipVendor:'Výrobca', certWith:'S certifikátom', certWithout:'Bez certifikátu',
  addToCart:'Do košíka', adding:'Pridávam...', added:'V košíku', chooseVariant:'Vybrať variant', detail:'Detail',
  cartError:'Nepodarilo sa pridať do košíka'
};

/* Hodnoty filtrov ostávajú slovenské (kvôli URL parametrom z hub sekcie),
   prekladá sa iba to, čo vidí zákazník. */
const CATEGORY_LABELS_EN = {
  'Krídla':'Wings','Bodykity':'Body kits','Karoséria':'Bodywork','Osvetlenie':'Lighting',
  'Náprava':'Suspension','Motor':'Engine','Prevodovka':'Transmission','Disky':'Wheels',
  'Brzdy':'Brakes','Doplnky':'Accessories','Garáž':'Garage','Interiér':'Interior',
  'Chladenie':'Cooling','Textil':'Apparel','Výfukový systém':'Exhaust system',
  'Výstuhy a klietky':'Bracing & cages','Riadenie a elektronika':'Electronics',
  'Oleje a filtre':'Oils & filters'
};
const BRAND_LABELS_EN = { 'Univerzálne':'Universal' };
const catLabel = v => (EN && CATEGORY_LABELS_EN[v]) || v;
const brandLabel = v => (EN && BRAND_LABELS_EN[v]) || v;

const $=id=>document.getElementById(id);
const vendorFilter=$('racemVendorFilter'),brandFilter=$('racemBrandFilter'),modelFilter=$('racemModelFilter');
const yearFilter=$('racemYearFilter'),categoryFilter=$('racemCategoryFilter'),certificateFilter=$('racemCertificateFilter');
const priceMinFilter=$('racemPriceMinFilter'),priceMaxFilter=$('racemPriceMaxFilter'),sortFilter=$('racemSortFilter');
const resetBtn=$('racemResetFilters'),activeFiltersEl=$('racemActiveFilters');
const resultsCount=$('racemResultsCount'),productsMount=$('racemProductsMount'),bgDot=$('racemBgDot');

/* Pocet produktov na stranu. Vyber si zapamataju v URL aj v prehliadaci. */
const PER_PAGE_OPTIONS=[25,50,100];
const PER_PAGE_KEY='racem_per_page';
function perPage(){
  const el=$('racemPerPage');
  const v=el?parseInt(el.value,10):25;
  return PER_PAGE_OPTIONS.indexOf(v)>-1?v:25;
}
/* Cache je per-jazyk — inak by EN verzia dostala slovenské názvy z SK cache. */
const CACHE_KEY='racem_offer_v36_'+LOCALE;
const CACHE_TTL=6*60*60*1000,PAGE_TIMEOUT=8000,MAX_PAGES=60;
const MTS_NORM='mts technik';

let allProducts=[],filteredProducts=[],visibleCount=0,debounceTimer=null;
/* Kategoria z URL sa nemusi dat pouzit hned, lebo pri prvom vykresleni je
   nacitana iba cast katalogu a dana kategoria este nemusi mat ziadny produkt.
   Preto si ju drzime a skusame znova po kazdej davke z pozadia. */
/* Vsetky filtre z URL, ktore este nesadli. Selecty su pri prvom vykresleni
   naplnene len z casti katalogu, takze znacka, model, rok ani vyrobca sa
   nemusia najst hned. Drzime ich tu a skusame po kazdej davke z pozadia. */
let pendingQuery=null;
/* Kolko produktov bolo videt a kde bol zakaznik, ked odchadzal na produkt. */
const STATE_KEY='racem_ponuka_state';
let restoreScrollTo=null;

/* ── poradie ──
   Predtym sa katalog miesal cez Math.random pri kazdej davke z pozadia,
   takze po kazdom dotiahnuti produktov sa poradie zmenilo a stranka
   sa nedala prekreslit bez toho, aby zakaznikovi poskakali dlazdice.
   Teraz je poradie odvodene od handle produktu, takze vyzera nahodne,
   ale je vzdy rovnake a prekreslenie je bezpecne. */
function hashStr(str){let h=2166136261;for(let i=0;i<str.length;i++){h^=str.charCodeAt(i);h=Math.imul(h,16777619);}return h>>>0;}
function stableOrder(arr){return arr.slice().sort((a,b)=>hashStr(String(a.handle||a.id||''))-hashStr(String(b.handle||b.id||'')));}

/* ── helpers ── */
const norm=s=>String(s||'').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
const esc=s=>String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
const uniq=arr=>[...new Set(arr.filter(Boolean))].sort((a,b)=>a.localeCompare(b,SORT_LOCALE,{numeric:true}));

function getTags(p){if(Array.isArray(p.tags))return p.tags.map(t=>String(t).trim()).filter(Boolean);if(typeof p.tags==='string')return p.tags.split(',').map(t=>t.trim()).filter(Boolean);return[];}
function cleanImg(src){if(!src)return'';src=String(src).trim();if(src.startsWith('//'))src='https:'+src;return src;}
function getProductImage(p){let src='';if(Array.isArray(p.images)&&p.images.length){const f=p.images.find(i=>i&&(i.src||typeof i==='string'));if(f)src=typeof f==='string'?f:(f.src||'');}if(!src&&p.image?.src)src=p.image.src;if(!src&&p.featured_image)src=p.featured_image;src=cleanImg(src);if(!src)return'';if(src.includes('cdn.shopify.com'))return src+(src.includes('?')?'&':'?')+'width=360';return src;}
function getPrice(p){const prices=(p.variants||[]).map(v=>parseFloat(String(v.price||'').replace(',','.'))).filter(n=>!isNaN(n)&&n>0);if(!prices.length)return{label:'',value:'',number:0};prices.sort((a,b)=>a-b);const min=prices[0],max=prices[prices.length-1];return{label:min!==max?T.from:T.price,value:min.toLocaleString(NUM_LOCALE,{minimumFractionDigits:2,maximumFractionDigits:2})+' €',number:min};}

const YRR=/\b(19\d{2}|20\d{2})\s*[-–—]\s*(19\d{2}|20\d{2})\b/g,YRS=/\b(19\d{2}|20\d{2})\b/g;
function detectYears(title){const t=String(title||'');YRR.lastIndex=0;const r=[...t.matchAll(YRR)].map(m=>({from:+m[1],to:+m[2]})).filter(r=>r.from>=1950&&r.to<=2050&&r.from<=r.to);if(r.length)return r.reduce((b,c)=>(c.to-c.from)<(b.to-b.from)?c:b);YRS.lastIndex=0;const s=[...t.matchAll(YRS)].map(m=>+m[1]).filter(y=>y>=1950&&y<=2050);return s.length?{from:s[0],to:s[0]}:null;}
const yearLabel=y=>y?(y.from===y.to?String(y.from):`${y.from}–${y.to}`):'';

/* ── brand / model data ── */
const brandAliases={"BMW":["bmw"],"Alfa Romeo":["alfa romeo","alfa"],"Audi":["audi"],"Volkswagen":["volkswagen","vw"],"Škoda":["skoda","škoda"],"SEAT":["seat"],"Cupra":["cupra"],"Nissan":["nissan"],"Toyota":["toyota"],"Mazda":["mazda"],"Honda":["honda"],"Subaru":["subaru"],"Mitsubishi":["mitsubishi"],"Mercedes-Benz":["mercedes","mercedes-benz","benz"],"AMG":["amg"],"JEEP":["jeep"],"Porsche":["porsche"],"Lexus":["lexus"],"Infiniti":["infiniti"],"Ford":["ford"],"Hyundai":["hyundai"],"Kia":["kia"],"Renault":["renault"],"Peugeot":["peugeot"],"Opel":["opel"],"Chevrolet":["chevrolet"],"Jaguar":["jaguar"],"Mini":["mini"],"Volvo":["volvo"],"Saab":["saab"],"Fiat":["fiat"],"Abarth":["abarth"],"Dodge":["dodge"],"Chrysler":["chrysler"],"Cadillac":["cadillac"],"Tesla":["tesla"],"Land Rover":["land rover","landrover"],"Range Rover":["range rover","rangerover"],"Suzuki":["suzuki"],"Isuzu":["isuzu"],"Daihatsu":["daihatsu"],"Smart":["smart"],"Ferrari":["ferrari"],"Lamborghini":["lamborghini","lambo"],"McLaren":["mclaren"],"Aston Martin":["aston martin"],"Bentley":["bentley"],"Rolls-Royce":["rolls royce","rolls-royce"],"Lotus":["lotus"],"Maserati":["maserati"],"Bugatti":["bugatti"],"Pagani":["pagani"],"Koenigsegg":["koenigsegg"],"Dacia":["dacia"],"Citroën":["citroen","citroën"],"DS":["ds"],"Lancia":["lancia"],"Rover":["rover"],"MG":["mg"],"Genesis":["genesis"],"Univerzálne":["univerzalne","universal"]};
const brandAliasNorms=Object.entries(brandAliases).map(([brand,aliases])=>({brand,norms:aliases.map(norm)}));

const modelMap={'145':'145','146':'146','147':'147','155':'155','156':'156','159':'159','166':'166','brera':'Brera','gt':'GT','giulia':'Giulia','giulietta':'Giulietta','mito':'MiTo','stelvio':'Stelvio','4c':'4C','8c':'8C','n53':'N53','e30':'E30','e36':'E36','e36m3':'E36 M3','e36 m3':'E36 M3','e46':'E46','e46m3':'E46 M3','e46 m3':'E46 M3','e60':'E60','e61':'E61','e81':'E81','e82':'E82','e87':'E87','e88':'E88','e90':'E90','e91':'E91','e92':'E92','e93':'E93','f20':'F20','f21':'F21','f22':'F22','f30':'F30','f31':'F31','f32':'F32','f33':'F33','f34':'F34','f36':'F36','f80':'F80','f82':'F82','f83':'F83','g20':'G20','g21':'G21','g22':'G22','g23':'G23','g26':'G26','g42':'G42','g80':'G80','g81':'G81','g82':'G82','g83':'G83','a1':'A1','a3':'A3','a4':'A4','a5':'A5','a6':'A6','a7':'A7','a8':'A8','s1':'S1','s3':'S3','s4':'S4','s5':'S5','s6':'S6','s7':'S7','rs3':'RS3','rs4':'RS4','rs5':'RS5','rs6':'RS6','tt':'TT','tts':'TTS','tt rs':'TT RS','ttrs':'TT RS','r8':'R8','golf 1':'Golf 1','golf i':'Golf 1','golf 2':'Golf 2','golf ii':'Golf 2','golf 3':'Golf 3','golf iii':'Golf 3','golf 4':'Golf 4','golf iv':'Golf 4','mk4':'Golf 4','golf 5':'Golf 5','golf v':'Golf 5','mk5':'Golf 5','golf 6':'Golf 6','golf vi':'Golf 6','mk6':'Golf 6','golf 7':'Golf 7','golf vii':'Golf 7','mk7':'Golf 7','golf 8':'Golf 8','golf viii':'Golf 8','mk8':'Golf 8','passat b5':'Passat B5','passat b5.5':'Passat B5.5','passat b55':'Passat B5.5','passat b6':'Passat B6','passat b7':'Passat B7','passat b8':'Passat B8','polo':'Polo','scirocco':'Scirocco','arteon':'Arteon','jetta':'Jetta','beetle':'Beetle','fabia 1':'Fabia 1','fabia i':'Fabia 1','fabia 2':'Fabia 2','fabia ii':'Fabia 2','fabia 3':'Fabia 3','fabia iii':'Fabia 3','fabia 4':'Fabia 4','fabia iv':'Fabia 4','octavia 1':'Octavia 1','octavia i':'Octavia 1','octavia 2':'Octavia 2','octavia ii':'Octavia 2','octavia 3':'Octavia 3','octavia iii':'Octavia 3','octavia 4':'Octavia 4','octavia iv':'Octavia 4','superb 1':'Superb 1','superb i':'Superb 1','superb 2':'Superb 2','superb ii':'Superb 2','superb 3':'Superb 3','superb iii':'Superb 3','kodiaq':'Kodiaq','karoq':'Karoq','scala':'Scala','leon':'Leon','leon 1':'Leon 1','leon 2':'Leon 2','leon 3':'Leon 3','leon 4':'Leon 4','leon 1m':'Leon 1M','leon 1p':'Leon 1P','leon 5f':'Leon 5F','ibiza':'Ibiza','toledo':'Toledo','formentor':'Formentor','ateca':'Ateca','arona':'Arona','exeo':'Exeo','alhambra':'Alhambra','350z':'350Z','370z':'370Z','s13':'S13','s14':'S14','s15':'S15','r32':'R32','r33':'R33','r34':'R34','r35':'R35','juke':'Juke','micra':'Micra','qashqai':'Qashqai','gt86':'GT86','gr86':'GR86','supra':'Supra','supra mk4':'Supra A80','a80':'Supra A80','supra a80':'Supra A80','supra mk5':'Supra A90','a90':'Supra A90','supra a90':'Supra A90','celica':'Celica','yaris gr':'Yaris GR','gr yaris':'Yaris GR','corolla':'Corolla','mx5':'MX-5','mx-5':'MX-5','miata':'MX-5','rx7':'RX-7','rx-7':'RX-7','rx8':'RX-8','rx-8':'RX-8','mazda 3':'Mazda 3','mazda 6':'Mazda 6','civic':'Civic','accord':'Accord','integra':'Integra','s2000':'S2000','crx':'CRX','prelude':'Prelude','brz':'BRZ','wrx':'WRX','wrx sti':'WRX STI','sti':'WRX STI','impreza':'Impreza','legacy':'Legacy','forester':'Forester','evo':'Lancer Evo','lancer':'Lancer','lancer evo':'Lancer Evo','colt':'Colt','eclipse':'Eclipse','w201':'W201','w202':'W202','w203':'W203','w204':'W204','w205':'W205','w206':'W206','w210':'W210','w211':'W211','w212':'W212','w213':'W213','cla':'CLA','cls':'CLS','a class':'A-Class','a-class':'A-Class','c class':'C-Class','c-class':'C-Class','e class':'E-Class','e-class':'E-Class','amg gtr':'AMG GT R','amg gt r':'AMG GT R','amg gt':'AMG GT','amg gts':'AMG GT S','amg gt s':'AMG GT S','c63':'C63 AMG','c63 amg':'C63 AMG','e63':'E63 AMG','e63 amg':'E63 AMG','mustang':'Mustang','s197':'Mustang S197','s550':'Mustang S550','focus':'Focus','fiesta':'Fiesta','mondeo':'Mondeo','i20':'i20','i30':'i30','elantra':'Elantra','veloster':'Veloster','coupe':'Coupe','genesis coupe':'Genesis Coupe','stinger':'Stinger','ceed':'Ceed',"cee'd":'Ceed','proceed':'Proceed','pro ceed':'Proceed','rio':'Rio','sportage':'Sportage','clio':'Clio','megane':'Megane','laguna':'Laguna','twingo':'Twingo','captur':'Captur','106':'106','206':'206','207':'207','208':'208','306':'306','307':'307','308':'308','406':'406','407':'407','508':'508','rcz':'RCZ','astra':'Astra','corsa':'Corsa','vectra':'Vectra','insignia':'Insignia','calibra':'Calibra','omega':'Omega','camaro':'Camaro','corvette':'Corvette','cruze':'Cruze','aveo':'Aveo','500':'500','500 abarth':'500 Abarth','punto':'Punto','bravo':'Bravo','stilo':'Stilo','cooper':'Cooper','clubman':'Clubman','countryman':'Countryman','r50':'R50','r52':'R52','r53':'R53','r55':'R55','r56':'R56','r57':'R57','r58':'R58','r59':'R59','r60':'R60','r61':'R61','f54':'F54','f55':'F55','f56':'F56','f57':'F57','f60':'F60','911':'911','996':'996','997':'997','991':'991','992':'992','boxster':'Boxster','cayman':'Cayman','panamera':'Panamera','c1':'C1','c2':'C2','c3':'C3','c4':'C4','c5':'C5','c6':'C6','saxo':'Saxo','xsara':'Xsara','charger':'Charger','challenger':'Challenger','viper':'Viper','durango':'Durango','458':'458','488':'488','f8':'F8','laferrari':'LaFerrari','california':'California','portofino':'Portofino','sf90':'SF90','812':'812 Superfast','812 superfast':'812 Superfast','aventador':'Aventador','huracan':'Huracan','gallardo':'Gallardo','murcielago':'Murcielago','urus':'Urus','300c':'300C','300':'300','pacifica':'Pacifica','wrangler':'Wrangler','grand cherokee':'Grand Cherokee','jeep xj':'XJ','xj':'XJ','compass':'Compass','renegade':'Renegade','g35':'G35','is200':'IS200','is250':'IS250','is300':'IS300','isf':'IS F','is f':'IS F','rcf':'RC F','rc f':'RC F','gs':'GS','ls':'LS','nx':'NX','rx':'RX','lx':'LX','elise':'Elise','exige':'Exige','evora':'Evora','emira':'Emira','model s':'Model S','model 3':'Model 3','model x':'Model X','model y':'Model Y','models':'Model S','model3':'Model 3','modelx':'Model X','modely':'Model Y'};
const modelEntries=Object.entries(modelMap).sort((a,b)=>b[0].length-a[0].length);

const brandAllowedModels={"BMW":["N53","E30","E36","E36 M3","E46","E46 M3","E60","E61","E81","E82","E87","E88","E90","E91","E92","E93","F20","F21","F22","F30","F31","F32","F33","F34","F36","F80","F82","F83","G20","G21","G22","G23","G26","G42","G80","G81","G82","G83"],"Alfa Romeo":["145","146","147","155","156","159","166","Brera","GT","Giulia","Giulietta","MiTo","Stelvio","4C","8C"],"Audi":["A1","A3","A4","A5","A6","A7","A8","S1","S3","S4","S5","S6","S7","RS3","RS4","RS5","RS6","TT","TTS","TT RS","R8"],"Volkswagen":["Golf 1","Golf 2","Golf 3","Golf 4","Golf 5","Golf 6","Golf 7","Golf 8","Passat B5","Passat B5.5","Passat B6","Passat B7","Passat B8","Polo","Scirocco","Arteon","Jetta","Beetle"],"Škoda":["Fabia 1","Fabia 2","Fabia 3","Fabia 4","Octavia 1","Octavia 2","Octavia 3","Octavia 4","Superb 1","Superb 2","Superb 3","Kodiaq","Karoq","Scala"],"SEAT":["Leon","Leon 1","Leon 2","Leon 3","Leon 4","Leon 1M","Leon 1P","Leon 5F","Ibiza","Toledo","Arona","Exeo","Alhambra"],"Cupra":["Formentor","Ateca","Leon"],"Nissan":["350Z","370Z","S13","S14","S15","R32","R33","R34","R35","Juke","Micra","Qashqai"],"Toyota":["GT86","GR86","Supra","Supra A80","Supra A90","Celica","Yaris GR","Corolla"],"Mazda":["MX-5","RX-7","RX-8","Mazda 3","Mazda 6"],"Honda":["Civic","Accord","Integra","S2000","CRX","Prelude"],"Subaru":["BRZ","WRX","WRX STI","Impreza","Legacy","Forester"],"Mitsubishi":["Lancer Evo","Lancer","Colt","Eclipse"],"Mercedes-Benz":["W201","W202","W203","W204","W205","W206","W210","W211","W212","W213","CLA","SLK","SLC","CLS","A-Class","C-Class","E-Class","AMG GT","AMG GT R","AMG GT S","C63 AMG","E63 AMG"],"AMG":["AMG GT","AMG GT R","AMG GT S","C63 AMG","E63 AMG"],"Ford":["Mustang","Mustang S197","Mustang S550","Focus","Fiesta","Mondeo"],"Hyundai":["i20","i30","Elantra","Veloster","Coupe","Genesis Coupe"],"Kia":["Stinger","Ceed","Proceed","Rio","Sportage"],"Renault":["Clio","Megane","Laguna","Twingo","Captur"],"Peugeot":["106","206","207","208","306","307","308","406","407","508","RCZ"],"Opel":["Astra","Corsa","Vectra","Insignia","Calibra","Omega"],"Chevrolet":["Camaro","Corvette","Cruze","Aveo"],"Fiat":["500","Punto","Bravo","Stilo"],"Abarth":["500 Abarth","Punto"],"Mini":["Cooper","Clubman","Countryman","R50","R52","R53","R55","R56","R57","R58","R59","R60","R61","F54","F55","F56","F57","F60"],"Porsche":["911","996","997","991","992","Boxster","Cayman","Panamera"],"Citroën":["C1","C2","C3","C4","C5","C6","Saxo","Xsara"],"Dodge":["Charger","Challenger","Viper","Durango"],"Ferrari":["458","488","F8","LaFerrari","California","Portofino","SF90","812 Superfast"],"Lamborghini":["Aventador","Huracan","Gallardo","Murcielago","Urus"],"Chrysler":["300C","300","Pacifica"],"JEEP":["Grand Cherokee","XJ","Wrangler","Compass","Renegade"],"Infiniti":["G35"],"Lexus":["IS200","IS250","IS300","IS F","RC F","GS","LS","NX","RX","LX"],"Lotus":["Elise","Exige","Evora","Emira"],"Tesla":["Model S","Model 3","Model X","Model Y"]};
const brandAllowedNorms={};
for(const [b,m] of Object.entries(brandAllowedModels)) brandAllowedNorms[norm(b)]=new Set(m.map(norm));

const categoryMap={'kridla':'Krídla','krídla':'Krídla','kridlo':'Krídla','wing':'Krídla','wings':'Krídla','rear spoiler':'Krídla','widebody':'Bodykity','wide body':'Bodykity','bodykit':'Bodykity','body kit':'Bodykity','bodykits':'Bodykity','aero kit':'Bodykity','aerokit':'Bodykity','karoseria':'Karoséria','air dam':'Karoséria','front air dam':'Karoséria','bumper canards':'Karoséria','canards':'Karoséria','front bumper canards':'Karoséria','brzdy':'Brzdy','brzdove kotuce':'Brzdy','brzdove platnicky':'Brzdy','vystuhy':'Výstuhy a klietky','rozpery':'Výstuhy a klietky','roll cage':'Výstuhy a klietky','rollcage':'Výstuhy a klietky','vyfukovy system':'Výfukový systém','priruby':'Výfukový systém','motor':'Motor','turbokit':'Motor','turbo kit':'Motor','riadiace jednotky':'Riadenie a elektronika','olej':'Oleje a filtre','oleje':'Oleje a filtre','filtre':'Oleje a filtre','garaz':'Garáž','naradie':'Garáž','osvetlenie':'Osvetlenie','naprava':'Náprava','prevodovka':'Prevodovka','disky':'Disky','chladenie':'Chladenie','interier':'Interiér','textil':'Textil','doplnky':'Doplnky','ostatne':'Doplnky'};
function getCategory(raw){const n=norm(raw);return categoryMap[n]||(raw?raw.charAt(0).toUpperCase()+raw.slice(1):'');}

function hasToken(text,key){if(!text||!key)return false;const t=norm(text).replace(/[_+.,;:]/g,' '),k=norm(key).replace(/[_+.,;:]/g,' ');if(!t.includes(k))return false;return new RegExp('(^|[\\s\\-\\/\\(\\)\\[\\]])'+k.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'([\\s\\-\\/\\(\\)\\[\\]]|$)','i').test(t);}

function detectBrand(p,tags){const tn=tags.map(norm),tx=[p.title,p.vendor,...tags].join(' ');if(tn.includes('univerzalne')||tn.includes('universal'))return'Univerzálne';for(const {brand,norms} of brandAliasNorms){if(norms.some(a=>tn.includes(a)))return brand;}for(const {brand,norms} of brandAliasNorms){if(norms.some(a=>hasToken(tx,a)))return brand;}return'';}

function detectModels(p,tags,brand){const found=new Set(),tx=norm([p.title,p.vendor,...tags].join(' ')).replace(/[_+.,;:]/g,' ');for(const [key,label] of modelEntries){if(tx.includes(norm(key)))found.add(label);}tags.forEach(tag=>{const n=norm(tag);if(modelMap[n])found.add(modelMap[n]);if(brand==='Mini'&&/^[rf]\d{2}$/i.test(tag.trim()))found.add(tag.trim().toUpperCase());});if(brand==='Mini'){(tx.match(/\b[rf]\d{2}\b/gi)||[]).forEach(m=>found.add(m.toUpperCase()));}const aset=brandAllowedNorms[norm(brand)];return uniq([...found].filter(m=>!aset||aset.has(norm(m))));}

/* ── memoizačný cache — každý produkt sa enrichuje len RAZ ── */
const _enrichBaseCache=new Map();
function getEnrichedBase(product){
  const key=product.id||product.handle;
  if(_enrichBaseCache.has(key))return _enrichBaseCache.get(key);
  const tags=getTags(product),brand=detectBrand(product,tags),models=detectModels(product,tags,brand),
    category=getCategory(product.product_type||''),hasCert=tags.some(t=>norm(t)==='certifikat'),
    price=getPrice(product),image=getProductImage(product),years=detectYears(product.title);
  const data={tags,brand,brandNorm:norm(brand),models,modelNorms:models.map(norm),
    vendorNorm:norm(product.vendor||''),category,categoryNorm:norm(category),
    hasCert,price,image,years,yearLabel:yearLabel(years)};
  _enrichBaseCache.set(key,data);
  return data;
}
function enrichProduct(product,index){
  return{...product,_r:{...getEnrichedBase(product),index}};
}

function buildAllProducts(raw){
  const rest=stableOrder(raw.filter(p=>norm(p.vendor||'')!==MTS_NORM));
  const mts=stableOrder(raw.filter(p=>norm(p.vendor||'')===MTS_NORM));
  return[...rest,...mts].map((p,i)=>enrichProduct(p,i));
}

/* ── fetch one page — cez ROOT, aby /en/products.json vrátil preložené názvy ── */
async function fetchPage(page){
  const ac=typeof AbortController!=='undefined'?new AbortController():null;
  const t=ac?setTimeout(()=>ac.abort(),PAGE_TIMEOUT):null;
  try{
    const res=await fetch(ROOT+'/products.json?limit=250&page='+page,{credentials:'same-origin',cache:'force-cache',signal:ac?ac.signal:undefined});
    if(t)clearTimeout(t);
    if(!res.ok)return{products:[],done:true};
    const d=await res.json();const pp=d.products||[];
    return{products:pp,done:pp.length<250};
  }catch(e){if(t)clearTimeout(t);return{products:[],done:false};}
}

/* ── paralelný fetch prvých 4 strán naraz ── */
async function fetchInitialPages(){
  const results=await Promise.all([1,2,3,4].map(fetchPage));
  const seen=new Set(),products=[];
  let lastLoaded=0,allDone=false;
  for(let i=0;i<results.length;i++){
    const r=results[i];
    for(const p of r.products){const k=p.id||p.handle;if(k&&!seen.has(k)){seen.add(k);products.push(p);}}
    if(r.products.length>0)lastLoaded=i+1;
    if(r.done){allDone=true;break;}
  }
  return{products,seen,nextPage:lastLoaded+1,done:allDone};
}

/* ── shared filter + sort ── */
function computeFiltered(){
  const vendor=norm(vendorFilter.value),brand=norm(brandFilter.value),model=norm(modelFilter.value),
    year=+(yearFilter.value||0),cat=norm(categoryFilter.value),cert=certificateFilter.value,
    min=+(priceMinFilter.value||0),max=+(priceMaxFilter.value||0),sort=sortFilter.value;
  const out=allProducts.filter(p=>{const r=p._r;
    if(vendor&&r.vendorNorm!==vendor)return false;
    if(brand&&r.brandNorm!==brand)return false;
    if(model&&!r.modelNorms.includes(model))return false;
    if(year&&r.years&&(year<r.years.from||year>r.years.to))return false;
    if(cat&&r.categoryNorm!==cat)return false;
    if(min&&r.price.number<min)return false;
    if(max&&r.price.number>max)return false;
    if(cert==='with'&&!r.hasCert)return false;
    if(cert==='without'&&r.hasCert)return false;
    return true;
  });
  out.sort((a,b)=>{switch(sort){case'cheap':return a._r.price.number-b._r.price.number;case'expensive':return b._r.price.number-a._r.price.number;case'az':return String(a.title||'').localeCompare(String(b.title||''),SORT_LOCALE,{numeric:true});case'za':return String(b.title||'').localeCompare(String(a.title||''),SORT_LOCALE,{numeric:true});case'newest':return new Date(b.created_at||0)-new Date(a.created_at||0);default:return a._r.index-b._r.index;}});
  return out;
}

function filterProducts(resetVisible=true){
  filteredProducts=computeFiltered();
  if(resetVisible)visibleCount=perPage();
  renderActiveFilters();updateUrl();renderProducts();saveState();
}

let lastRenderedCount=-1;
function silentUpdate(){
  buildFilters();
  /* Ked kategoria z URL este nesadla, skus to teraz s novymi datami. */
  const landed=applyPendingFilters();
  filteredProducts=computeFiltered();
  resultsCount.textContent=filteredProducts.length+' '+T.products;
  if(landed){
    renderActiveFilters();updateUrl();visibleCount=perPage();renderProducts();
    return;
  }
  /* Z pozadia dorazili dalsie produkty, ktore patria do aktualneho filtra.
     Predtym sa dopocitali iba do cisla a v mriezke sa neobjavili, kym
     zakaznik neprepol filter inam a spat. Teraz sa domaluju samy. */
  if(filteredProducts.length!==lastRenderedCount){
    renderProducts();
  }
}

async function loadInBackground(seen,raw,startPage=2){
  if(bgDot)bgDot.classList.add('active');
  let emptyStreak=0,silentPending=false;

  const debouncedSilentUpdate=()=>{
    if(silentPending)return;
    silentPending=true;
    setTimeout(()=>{
      allProducts=buildAllProducts(raw);
      silentUpdate();
      silentPending=false;
    },300);
  };

  for(let page=startPage;page<=MAX_PAGES;page++){
    const r=await fetchPage(page);
    if(!r.products.length){if(++emptyStreak>=2)break;continue;}
    emptyStreak=0;
    let added=false;
    for(const p of r.products){const k=p.id||p.handle;if(k&&!seen.has(k)){seen.add(k);raw.push(p);added=true;}}
    if(added)debouncedSilentUpdate();
    if(r.done)break;
  }
  allProducts=buildAllProducts(raw);
  silentUpdate();
  try{localStorage.setItem(CACHE_KEY,JSON.stringify({time:Date.now(),products:raw}));}catch(_){}
  if(bgDot)bgDot.classList.remove('active');
}

/* ── filter UI — hodnota ostáva SK, popisok sa prekladá ── */
function fillSelect(sel,lbl,vals,labelFn){
  const cur=sel.value;
  const map=labelFn||(v=>v);
  sel.innerHTML=`<option value="">${esc(lbl)}</option>`+vals.map(v=>`<option value="${esc(v)}">${esc(map(v))}</option>`).join('');
  if([...sel.options].some(o=>o.value===cur))sel.value=cur;
}
function buildYearOptions(){let yrs=uniq(allProducts.flatMap(p=>{if(!p._r.years)return[];const o=[];for(let y=p._r.years.from;y<=p._r.years.to;y++)o.push(String(y));return o;})).sort((a,b)=>+b-+a);if(!yrs.length){const c=new Date().getFullYear();yrs=Array.from({length:c-1979},(_,i)=>String(c+1-i));}fillSelect(yearFilter,T.allYears,yrs);}
function buildFilters(){
  fillSelect(vendorFilter,T.allVendors,uniq(allProducts.map(p=>p.vendor)));
  fillSelect(brandFilter,T.allBrands,uniq(allProducts.map(p=>p._r.brand)),brandLabel);
  fillSelect(categoryFilter,T.allCategories,uniq(allProducts.map(p=>p._r.category)),catLabel);
  buildYearOptions();
  buildModelOptions(brandFilter.value||'');
}
function buildModelOptions(sel){if(!sel||norm(sel)===norm('Univerzálne')){modelFilter.innerHTML=`<option value="">${esc(T.pickBrand)}</option>`;modelFilter.disabled=true;return;}const bn=norm(sel),ms=uniq(allProducts.filter(p=>p._r.brandNorm===bn).flatMap(p=>p._r.models)),cur=modelFilter.value;modelFilter.innerHTML=`<option value="">${esc(T.allModels)}</option>`+ms.map(m=>`<option value="${esc(m)}">${esc(m)}</option>`).join('');if([...modelFilter.options].some(o=>o.value===cur))modelFilter.value=cur;modelFilter.disabled=!ms.length;}

function renderActiveFilters(){
  const chips=[];
  const add=(l,v)=>{if(v)chips.push(`<span class="racem-offer-chip"><strong>${esc(l)}:</strong> ${esc(v)}</span>`);};
  add(T.chipBrand,brandLabel(brandFilter.value));
  add(T.chipModel,modelFilter.value);
  add(T.chipYear,yearFilter.value);
  add(T.chipCategory,catLabel(categoryFilter.value));
  if(priceMinFilter.value)add(T.chipPriceFrom,priceMinFilter.value+' €');
  if(priceMaxFilter.value)add(T.chipPriceTo,priceMaxFilter.value+' €');
  if(sortFilter.value&&sortFilter.value!=='best')add(T.chipSort,sortFilter.options[sortFilter.selectedIndex].text);
  if(certificateFilter.value==='with')add(T.certificate,T.certWith);
  if(certificateFilter.value==='without')add(T.certificate,T.certWithout);
  add(T.chipVendor,vendorFilter.value);
  activeFiltersEl.innerHTML=chips.join('');
  activeFiltersEl.classList.toggle('is-visible',chips.length>0);
}

function updateUrl(){const url=new URL(window.location.href);const p={vendor:vendorFilter.value,brand:brandFilter.value,model:modelFilter.value,year:yearFilter.value,category:categoryFilter.value,certificate:certificateFilter.value,min:priceMinFilter.value,max:priceMaxFilter.value,sort:sortFilter.value,per:(perPage()===25?'':String(perPage()))};Object.entries(p).forEach(([k,v])=>{v&&!(k==='sort'&&v==='best')?url.searchParams.set(k,v):url.searchParams.delete(k);});history.replaceState({},'',url.toString());}

/* Skusi nasadit vsetky cakajuce filtre. Kazdy, ktory sadne, sa odstrani.
   Vrati true, ked sa aspon jeden podaril, takze sa oplati prekreslit. */
function applyPendingFilters(){
  if(!pendingQuery)return false;
  let landed=false;

  const pick=(sel,key)=>{
    const want=pendingQuery[key];
    if(!want)return;
    const o=[...sel.options].find(o=>o.value&&norm(o.value)===norm(want));
    if(o){sel.value=o.value;delete pendingQuery[key];landed=true;}
  };

  pick(vendorFilter,'vendor');
  pick(brandFilter,'brand');
  if(pendingQuery.model){
    buildModelOptions(brandFilter.value);
    pick(modelFilter,'model');
  }
  pick(yearFilter,'year');

  if(pendingQuery.category){
    const raw=pendingQuery.category;
    const target=getCategory(raw);
    const opts=[...categoryFilter.options].filter(o=>o.value);
    const o=opts.find(x=>norm(x.value)===norm(target))
          ||opts.find(x=>norm(x.value)===norm(raw))
          ||opts.find(x=>norm(x.value).indexOf(norm(raw))>-1||norm(raw).indexOf(norm(x.value))>-1);
    if(o){categoryFilter.value=o.value;delete pendingQuery.category;landed=true;}
  }

  if(!Object.keys(pendingQuery).length)pendingQuery=null;
  return landed;
}

/* Ulozenie stavu pri odchode na produkt. sessionStorage zije iba v tejto
   zalozke, takze po zatvoreni prehliadaca je stav prec, presne ako ma byt. */
function saveState(){
  try{
    sessionStorage.setItem(STATE_KEY,JSON.stringify({
      url:window.location.search,
      visible:visibleCount,
      scroll:window.scrollY||window.pageYOffset||0,
      time:Date.now()
    }));
  }catch(_){}
}

function readState(){
  try{
    const st=JSON.parse(sessionStorage.getItem(STATE_KEY)||'null');
    if(!st||!st.time)return null;
    if(Date.now()-st.time>2*60*60*1000)return null;
    return st;
  }catch(_){return null;}
}

function applyInitialQuery(){
  let search=window.location.search;
  const st=readState();

  /* Ked sa zakaznik vratil z produktu a v adrese nie su filtre,
     obnovime tie, s ktorymi odchadzal. */
  if(st&&!search.replace('?','')&&st.url){
    search=st.url;
    try{history.replaceState({},'',window.location.pathname+st.url);}catch(_){}
  }

  const q=new URLSearchParams(search);

  pendingQuery={
    vendor:q.get('vendor')||'',
    brand:q.get('brand')||'',
    model:q.get('model')||'',
    year:q.get('year')||'',
    category:q.get('category')||''
  };
  Object.keys(pendingQuery).forEach(k=>{if(!pendingQuery[k])delete pendingQuery[k];});
  if(!Object.keys(pendingQuery).length)pendingQuery=null;
  applyPendingFilters();

  const cert=q.get('certificate')||'';
  if(cert==='with'||cert==='without')certificateFilter.value=cert;
  if(q.get('min'))priceMinFilter.value=q.get('min');
  if(q.get('max'))priceMaxFilter.value=q.get('max');
  const sort=q.get('sort')||'';
  if(sort&&[...sortFilter.options].some(o=>o.value===sort))sortFilter.value=sort;

  /* Pocet zobrazenych produktov aj poloha na stranke sa obnovia tiez,
     inak by zakaznik po navrate zacinal opat od prvych 25. */
  if(st&&st.url===search){
    if(st.visible&&st.visible>perPage())visibleCount=st.visible;
    if(st.scroll>0)restoreScrollTo=st.scroll;
  }
}

/* ── render ── */
function markLoaded(img){img.closest('.racem-product-media')?.classList.add('is-loaded');}
function markError(img){const m=img.closest('.racem-product-media');if(m){m.classList.add('is-loaded','is-error');img.remove();}}
window.racemImgLoad=markLoaded;window.racemImgErr=markError;

function hydrateImages(){productsMount.querySelectorAll('.racem-product-media img').forEach(img=>{if(img.complete&&img.naturalWidth>0){markLoaded(img);return;}img.addEventListener('load',()=>markLoaded(img),{once:true});img.addEventListener('error',()=>markError(img),{once:true});});}

function productCard(p){
  const r=p._r;
  const img=r.image?`<span class="racem-product-img-spinner" aria-hidden="true"></span><img src="${esc(r.image)}" alt="" loading="lazy" decoding="async" onload="racemImgLoad(this)" onerror="racemImgErr(this)">`:`<span class="racem-product-img-spinner" aria-hidden="true"></span>`;
  const cert=r.hasCert?`<span class="racem-product-cert-badge"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 7L9 18l-5-5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>${esc(T.certified)}</span>`:'';
  const pl=r.price.label?`<small>${esc(r.price.label)}</small>`:'';
  /* Tlacidlo do kosika iba pri jednom variante, ktory je skladom.
     Pri viacerych variantoch nema prehliadac ako vediet, ktory chce zakaznik,
     takze karta vedie na produkt, kde si ho vyberie. */
  const vs=p.variants||[];
  const single=vs.length===1&&vs[0]&&vs[0].available!==false;
  const btn=single
    ? `<button type="button" class="racem-add" data-vid="${esc(vs[0].id)}">${esc(T.addToCart)}</button>`
    : `<a class="racem-add racem-add--link" href="${ROOT}/products/${esc(p.handle)}">${esc(vs.length>1?T.chooseVariant:T.detail)}</a>`;
  return`<div class="racem-product-card"><a class="racem-product-link" href="${ROOT}/products/${esc(p.handle)}"><div class="racem-product-media">${img}</div><div class="racem-product-body"><div class="racem-product-title">${esc(p.title||'')}</div><div class="racem-product-price-row"><div class="racem-product-price">${pl}${r.price.value?esc(r.price.value):''}</div>${cert}</div></div></a>${btn}</div>`;
}

function renderProducts(){
  resultsCount.textContent=filteredProducts.length+' '+T.products;
  lastRenderedCount=filteredProducts.length;
  if(!allProducts.length){productsMount.innerHTML='<div class="racem-offer-spinner-wrap"><div class="racem-offer-spinner"></div></div>';return;}
  if(!filteredProducts.length){productsMount.innerHTML=`<div class="racem-offer-empty">${esc(T.noProducts)}</div>`;return;}
  const slice=filteredProducts.slice(0,visibleCount);
  const more=visibleCount<filteredProducts.length?`<div style="display:flex;justify-content:center;margin-top:18px;"><button type="button" class="racem-offer-reset" id="racemLoadMore" style="max-width:190px;">${esc(T.loadMore)}</button></div>`:'';
  productsMount.innerHTML=`<div class="racem-offer-grid">${slice.map(productCard).join('')}</div>${more}`;
  hydrateImages();
  if(restoreScrollTo!==null){
    const y=restoreScrollTo;restoreScrollTo=null;
    requestAnimationFrame(()=>window.scrollTo(0,y));
  }
  $('racemLoadMore')?.addEventListener('click',()=>{visibleCount+=perPage();renderProducts();saveState();});
}

/* Pridanie do kosika bez opustenia stranky. */
async function addToCart(btn){
  const id=btn.dataset.vid;
  if(!id||btn.disabled)return;
  const original=btn.textContent;
  btn.disabled=true;btn.textContent=T.adding;
  try{
    const res=await fetch(ROOT+'/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity:1}]})
    });
    if(!res.ok)throw new Error('add failed');
    btn.classList.add('is-added');btn.textContent=T.added;
    /* Prebudime pocitadlo kosika v teme. */
    document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true}));
    setTimeout(()=>{btn.classList.remove('is-added');btn.textContent=original;btn.disabled=false;},1800);
  }catch(e){
    btn.textContent=T.cartError;
    setTimeout(()=>{btn.textContent=original;btn.disabled=false;},1800);
  }
}

function bindEvents(){
  /* Stav sa uklada priebezne, aby prezil aj zavretie zalozky krizikom
     na produkte a navrat cez historiu. */
  let saveTimer=null;
  const queueSave=()=>{clearTimeout(saveTimer);saveTimer=setTimeout(saveState,250);};
  window.addEventListener('scroll',queueSave,{passive:true});
  window.addEventListener('pagehide',saveState);
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')saveState();});

  /* Klik na produkt: stav ulozime hned, nie az cez debounce. */
  productsMount.addEventListener('click',e=>{
    if(e.target.closest('.racem-product-link'))saveState();
  });

  productsMount.addEventListener('click',e=>{
    const btn=e.target.closest('.racem-add[data-vid]');
    if(!btn)return;
    e.preventDefault();
    addToCart(btn);
  });

  const pp=$('racemPerPage');
  if(pp){
    let saved=null;
    try{saved=localStorage.getItem(PER_PAGE_KEY);}catch(_){}
    const fromUrl=new URL(window.location.href).searchParams.get('per');
    const start=fromUrl||saved;
    if(start&&PER_PAGE_OPTIONS.indexOf(parseInt(start,10))>-1)pp.value=String(parseInt(start,10));
    pp.addEventListener('change',()=>{
      try{localStorage.setItem(PER_PAGE_KEY,pp.value);}catch(_){}
      visibleCount=perPage();
      updateUrl();
      renderProducts();
      window.scrollTo({top:document.getElementById('racemOfferPage').offsetTop-20,behavior:'smooth'});
    });
  }

  [vendorFilter,categoryFilter,certificateFilter,sortFilter].forEach(el=>el.addEventListener('change',()=>filterProducts(true)));
  [priceMinFilter,priceMaxFilter].forEach(el=>el.addEventListener('input',()=>{clearTimeout(debounceTimer);debounceTimer=setTimeout(()=>filterProducts(true),220);}));
  brandFilter.addEventListener('change',()=>{buildModelOptions(brandFilter.value);modelFilter.value='';filterProducts(true);});
  modelFilter.addEventListener('change',()=>filterProducts(true));
  yearFilter.addEventListener('change',()=>filterProducts(true));
  resetBtn.addEventListener('click',()=>{vendorFilter.value='';brandFilter.value='';categoryFilter.value='';certificateFilter.value='';modelFilter.value='';yearFilter.value='';priceMinFilter.value='';priceMaxFilter.value='';sortFilter.value='best';buildModelOptions('');filterProducts(true);});
}

async function init(){
  /* prázdne selecty naplníme predtým, než dorazia dáta */
  fillSelect(brandFilter,T.allBrands,[]);
  fillSelect(yearFilter,T.allYears,[]);
  fillSelect(categoryFilter,T.allCategories,[]);
  fillSelect(vendorFilter,T.allVendors,[]);
  modelFilter.innerHTML=`<option value="">${esc(T.pickBrand)}</option>`;

  bindEvents();

  try{
    const cached=JSON.parse(localStorage.getItem(CACHE_KEY)||'null');
    if(cached?.time&&Date.now()-cached.time<CACHE_TTL&&Array.isArray(cached.products)&&cached.products.length){
      const raw=cached.products.slice();
      allProducts=buildAllProducts(raw);
      buildFilters();applyInitialQuery();filterProducts(true);
      const seen=new Set(raw.map(p=>p.id||p.handle).filter(Boolean));
      loadInBackground(seen,raw,2);
      return;
    }
  }catch(_){}

  resultsCount.textContent=T.loading;
  const{products:raw,seen,nextPage,done}=await fetchInitialPages();

  if(!raw.length){
    resultsCount.textContent=T.loadError;
    productsMount.innerHTML=`<div class="racem-offer-empty">${esc(T.loadFailed)}</div>`;
    return;
  }

  allProducts=buildAllProducts(raw);
  buildFilters();applyInitialQuery();filterProducts(true);

  if(!done){
    loadInBackground(seen,raw.slice(),nextPage);
  }else{
    try{localStorage.setItem(CACHE_KEY,JSON.stringify({time:Date.now(),products:raw}));}catch(_){}
  }
}

/* Ked prehliadac vrati stranku z pamate (back tlacidlo), filtre
   uz su nastavene a netreba nic robit. Ked ju postavi nanovo, prebehne init. */
window.addEventListener('pageshow',e=>{
  if(e.persisted&&allProducts.length){
    renderActiveFilters();
  }
});

init();
})();